import getArrayDepth from '@/utils/getArrayDepth';

const createPolygon = ({
  coords = [],
  map,
  google,
  polygonOptions,
}) => {
  let coordsGroup = coords;
  const polygons = [];
  /**
   * Coords can be:
   * - []: Empty array, no polygon.
   * - [[[lng, lat]],..]: One ore more arrays inside, each one with a different polygon to draw.
   */

  const bounds = new google.maps.LatLngBounds();

  const coordsDepth = getArrayDepth(coordsGroup);

  if (coordsDepth === 3) {
    coordsGroup = [coordsGroup];
  }

  coordsGroup.forEach((group) => {
    group.forEach((pol) => {
      const polygonCoords = pol.map(([lng, lat]) => {
        const latlng = new google.maps.LatLng(lat, lng);
        bounds.extend(latlng);
        return latlng;
      });

      // Construct the polygon.
      polygons.push(new google.maps.Polygon({
        paths: polygonCoords,
        ...polygonOptions,
      }));

      polygons[polygons.length - 1].setMap(map);
    });
  });

  // Center polygon/s
  map.fitBounds(bounds);

  return polygons;
};

export default createPolygon;
